
  document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;

    let mainSwiper = null;

    function initGallery() {
      if (mainSwiper) mainSwiper.destroy(true, true);

      mainSwiper = new Swiper(gallery.querySelector('.pdp-gallery-main'), {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: gallery.querySelector('.pdp-gallery-main .swiper-button-next'),
          prevEl: gallery.querySelector('.pdp-gallery-main .swiper-button-prev'),
        },
        pagination: {
          el: gallery.querySelector('.pdp-gallery-main .swiper-pagination'),
          clickable: true,
        },

        /* ✅ Swiper Zoom module */
        zoom: {
          maxRatio: 3,
        },
      });

      const thumbs = Array.from(gallery.querySelectorAll('.pdp-thumb'));

      function setActiveThumb(index) {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        if (thumbs[index]) thumbs[index].classList.add('is-active');
      }

      setActiveThumb(0);

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.thumbIndex);
          mainSwiper.slideTo(index);
          setActiveThumb(index);
        });
      });

      mainSwiper.on('slideChange', () => {
        setActiveThumb(mainSwiper.activeIndex);
      });
    }

    initGallery();
  });
